import { Module } from 'vuex';
import {
  action,
  actionCreatorFactory,
  combineAction,
  combineMutation,
  mutation,
} from 'vuex-typescript-fsa/lib';
import { RootState } from '@/store';

export const namespace = 'error';
const actionCreator = actionCreatorFactory(namespace);
export const SetErrors = actionCreator<string[]>('SET_ERRORS');
export const ClearErrors = actionCreator<null>('CLEAR_ERRORS');

export interface State {
  errors: string[];
}

const initialState = (): State => {
  return { errors: [] };
};

export const module: Module<State, RootState> = {
  namespaced: true,
  state: initialState,
  actions: combineAction(
    action(SetErrors, function(context, action) {
      context.commit(SetErrors(action.payload));
    }),
    action(ClearErrors, function(context, action) {
      context.commit(ClearErrors(action.payload));
    })
  ),
  mutations: combineMutation(
    mutation(SetErrors, (state, action) => {
      state.errors = action.payload;
    }),
    mutation(ClearErrors, state => {
      state.errors = [];
    })
  ),
  getters: {
    hasError: state => state.errors.length > 0,
    errors: state => state.errors,
  },
};
